import { css } from "styled-components"

export const HeroOverlay = css`
  background: #282828;
  mix-blend-mode: multiply;
`
